import Footer from '../../footer/Footer';
import Header from '../../header/Header';
import Helmet from 'react-helmet';
import { Outlet, useLocation } from 'react-router-dom';
import {
	Favicon,
	Loader,
	ButtonLink,
	Icon,
	Checkbox,
	Button,
} from '@/components/ui';
import { useSelector } from 'react-redux';
import {
	getMapStatus,
	getShowAfterRegisterPreorderWarning,
	getShowDecemberPromoPopupStatus,
	getShowTariffsGuestPopup,
	setShowAfterRegisterPreorderWarning,
	setShowDecemberPromoPopup,
} from '@/stores/slices/popupSlice';
import MapFilter from '../../mapFilter/MapFilter';
import { useEffect, useState } from 'react';
import useLadyService from '@/services/LadyService';
import { makeRequest } from '@/services/makeRequest';
import { Link } from 'react-router-dom';

import {
	setActionsCountStatus,
	setAddressStatus,
	setAgency,
	setBlockedCountriesList,
	setCitiesListStatus,
	setCityIdStatus,
	setNotifyPartiesStatus,
	setCityStatus,
	setEmailStatus,
	setEmailVerifiedAtStatus,
	setFiltersCountStatus,
	setLatitudeStatus,
	setLongitudeStatus,
	setNotifyEmailStatus,
	setNotifyTelegramStatus,
	setNotifyWhatsappStatus,
	setPhoneStatus,
	setProfilesCountStatus,
	setProfileStatus,
	setSalonStatus,
	setSettingsOperatorStatus,
	setTelegramStatus,
	setWhatsappStatus,
	setPreviewPrice,
	setPreviewStatus,
} from '../../../stores/slices/userProfileSlice';
import { setUserInfoAlreadyExist } from '@/stores/slices/userSlice';
import userProfileService from '@/services/UserProfileService';
import { setElitePrice, setUserInfo } from '../../../stores/slices/userSlice';
import Filter from '@/components/filter/Filter';
import { showFilter } from '@/stores/slices/showFilterSlice';
import { AfterAuth, Popup } from '@/components/popups';
import {
	getInsufFundsForActivationStatus,
	setInsufFundsForActivationStatus,
} from '@/stores/slices/popupSlice';
import InsufFundsForActivationpopup from '@/components/popups/fundsForActivation/insufFundsForActivationpopup';
import TarrifsListPopup from '@/components/popups/TarrifsListPopup/TarrifsListPopup';
import {
	getGmapsApiReady,
	setGmapsApiReady,
} from '@/stores/slices/mapModelSlice';

const LayoutLk = ({ titleParams, postDesc }) => {
	const mapPopupStatus = useSelector(getMapStatus);
	const {
		dispatch,
		lang,
		userTypeIndi,
		userTypeAgency,
		userTypeCustomer,
		token,
		t,
		windowWidth,
	} = useLadyService();

	const location = useLocation();

	const filterValue = useSelector(showFilter);
	const insuffForAuto = useSelector(getInsufFundsForActivationStatus);
	const tariffsGuestPopup = useSelector(getShowTariffsGuestPopup);

	const [isLoading, setIsLoading] = useState(true);

	const decemberPromoPopup = useSelector(getShowDecemberPromoPopupStatus);

	const chekDecemberPromo = () => {
		// пасха
		const now = new Date();
		const startDate = new Date('2026-03-23T00:00:00Z');
		const endDate = new Date('2026-04-06T23:59:59Z');

		if (now >= startDate && now <= endDate) {
			const lastCheck = localStorage.getItem('lastCheckCristmasPromo');

			if (!lastCheck) {
				localStorage.setItem(
					'lastCheckCristmasPromo',
					now.toISOString(),
				);
				dispatch(setShowDecemberPromoPopup(true));
			} else {
				const lastDate = new Date(lastCheck);
				const diffMs = now - lastDate;
				const oneWeekMs = 7 * 24 * 60 * 60 * 1000;

				if (diffMs >= oneWeekMs) {
					dispatch(setShowDecemberPromoPopup(true));
					localStorage.setItem(
						'lastCheckCristmasPromo',
						now.toISOString(),
					);
				}
			}
		}
	};

	const [agreeWithTherms, setAgreeWithTherms] = useState(false);

	const [dataInfo, setDataInfo] = useState({});

	useEffect(() => {
		const getInfo = async () => {
			try {
				setIsLoading(true);

				const data = await makeRequest({
					route: `user/info`,
					method: 'GET',
				});

				if (data) {
					const result = data.data;

					setDataInfo(result);

					if (result.settings) {
						dispatch(setSettingsOperatorStatus(result?.settings));
					}
					if (result.phone) {
						dispatch(
							setUserInfo({
								stateName: 'phone',
								value: result.phone,
							}),
						);
					}
					if (result.email) {
						dispatch(
							setUserInfo({
								stateName: 'email',
								value: result.email,
							}),
						);
					}
					await dispatch(setProfileStatus(result.profiles_status));

					await dispatch(setFiltersCountStatus(result.filters_count));
					await dispatch(
						setProfilesCountStatus(result.profiles_count),
					);
					await dispatch(setActionsCountStatus(result.actions_count));

					await dispatch(setNotifyEmailStatus(result.notify_email));
					await dispatch(
						setNotifyTelegramStatus(result.notify_telegram),
					);
					await dispatch(
						setNotifyWhatsappStatus(result.notify_whatsapp),
					);

					await dispatch(setTelegramStatus(result.telegram));
					await dispatch(setWhatsappStatus(result.whatsapp));
					await dispatch(setEmailStatus(result.email));
					await dispatch(
						setEmailVerifiedAtStatus(result.email_verified_at),
					);
					await dispatch(setPhoneStatus(result.phone));
					await dispatch(setSalonStatus(result.salon));

					await dispatch(setLatitudeStatus(result.latitude));
					await dispatch(setLongitudeStatus(result.longitude));
					await dispatch(setCityStatus(result.city));
					await dispatch(setCityIdStatus(result.city_id));
					await dispatch(
						setNotifyPartiesStatus(result.new_parties_notify),
					);
					await dispatch(
						setElitePrice({
							oldPrice: result.old_elite_price,
							currentPrice: result.elite_price,
						}),
					);
					if (result.agency) {
						await dispatch(setAgency(result.agency.data));
						await dispatch(
							setAddressStatus(result.agency.data.address),
						);
						await dispatch(
							setPreviewStatus(
								result.agency.data.settings.preview_status,
							),
						);
						await dispatch(
							setPreviewPrice(
								result.agency.data.settings.preview_price,
							),
						);
					} else {
						await dispatch(setAddressStatus(result.address));
					}
					await dispatch(
						setBlockedCountriesList(result.blocked_countries),
					);
					await dispatch(setUserInfoAlreadyExist());

					// check if popup showed once per day
					if (result.has_enough_profile_renewal_funds === false) {
						const lastCheck = localStorage.getItem('lastCheckDate');
						const now = new Date();

						if (!lastCheck) {
							dispatch(setInsufFundsForActivationStatus(true));
							localStorage.setItem(
								'lastCheckDate',
								now.toISOString(),
							);
						} else {
							const lastDate = new Date(lastCheck);
							const diffMs = now - lastDate;
							const oneDayMs = 24 * 60 * 60 * 1000;

							if (diffMs >= oneDayMs) {
								dispatch(
									setInsufFundsForActivationStatus(true),
								);
								localStorage.setItem(
									'lastCheckDate',
									now.toISOString(),
								);
							}
						}
					}

					// check cristmass
					chekDecemberPromo();

					//check terms
					if (localStorage.getItem('check_terms') === 'unchecked') {
						dispatch(setShowAfterRegisterPreorderWarning(true));
					}
				}
			} catch (error) {
				console.error('error: ', error);
			}
		};

		const citiesData = async () => {
			try {
				const { cities } = await makeRequest({
					route: `services/all`,
					method: 'GET',
					payload: { lang },
				});
				if (cities) {
					await dispatch(setCitiesListStatus(cities));
				}
			} catch (error) { }
		};

		if (token) {
			getInfo()
				.then(citiesData)
				.finally(() => setIsLoading(false));
		}
	}, [token]);

	const showAfterRegisterPreorderWarning = useSelector(
		getShowAfterRegisterPreorderWarning,
	);

	const langs = ['cz', 'ru', 'en', 'sk', 'de'];

	const apiReady = useSelector(getGmapsApiReady);

	const mapLink = `https://maps.googleapis.com/maps/api/js?key=AIzaSyA81vyhvrBl3jUTFDK6LwYNm317prcxfVo&libraries=places&language=en`;

	const loadScript = async (retryCount = 0) => {
		return new Promise((resolve, reject) => {
			const script = document.createElement('script');
			script.src = mapLink;
			script.async = true;

			script.onload = () => {
				// console.log("%cGoogle Maps API loaded successfully. ", "color: green; font-size: 8px");
				dispatch(setGmapsApiReady(true));
				resolve();
			};

			script.onerror = () => {
				// console.error("%cGoogle Maps API failed to load.", "color: red; font-size: 8px");
				if (retryCount < 5) {
					// console.log(`%cRetrying to load Google Maps API... Attempt: ${retryCount + 1}`, "color: orange; font-size: 8px");
					setTimeout(() => {
						loadScript(retryCount + 1)
							.then(resolve)
							.catch(reject);
					}, 1000);
				} else {
					reject(
						new Error(
							'Google Maps API failed to load after multiple attempts.',
						),
					);
				}
			};

			document.body.appendChild(script);
		});
	};

	useEffect(() => {
		if (!apiReady) {
			loadScript()
				.then(() => {
					// console.log("%cGoogle Maps API loaded successfully. ", "color: green; font-size: 8px");
					dispatch(setGmapsApiReady(true));
				})
				.catch((error) => {
					console.error(
						`%cError loading Google Maps API: ${error}`,
						'color: red; font-size: 8px',
					);
				});
		}
	}, []);

	return (
		<>
			<Favicon />
			<Helmet>
				<title>{titleParams}</title>
				<meta
					name="description"
					content={postDesc}
				/>
				<meta
					property="og:title"
					content={titleParams}
				/>
				<meta
					property="og:type"
					content="website"
				/>
				<meta
					property="og:url"
					content={'https://lady4love.com' + location.pathname}
				/>
				<meta
					property="og:description"
					content={postDesc}
				/>
				<meta
					property="og:locale"
					content={lang === 'cz' ? 'cs' : lang}
				/>
				{langs
					.filter((i) => {
						switch (lang) {
							case 'cz': {
								return i !== 'cs';
							}
							default: {
								return i !== lang;
							}
						}
					})
					.map((i, idx) => (
						<meta
							key={'og:locale:alternate_' + idx}
							property="og:locale:alternate"
							content={i}
						/>
					))}
				<meta
					property="og:site_name"
					content="Lady4Love"
				/>

				<link
					rel="alternate"
					hreflang="en"
					href={
						'https://lady4love.com' +
						location.pathname.replace(`/${lang}`, '/en')
					}
				/>
				<link
					rel="alternate"
					hreflang="ru"
					href={
						'https://lady4love.com' +
						location.pathname.replace(`/${lang}`, '/ru')
					}
				/>
				<link
					rel="alternate"
					hreflang="cs"
					href={
						'https://lady4love.com' +
						location.pathname.replace(`/${lang}`, '/cz')
					}
				/>
				<link
					rel="alternate"
					hreflang="de"
					href={
						'https://lady4love.com' +
						location.pathname.replace(`/${lang}`, '/de')
					}
				/>
				<link
					rel="alternate"
					hreflang="sk"
					href={
						'https://lady4love.com' +
						location.pathname.replace(`/${lang}`, '/sk')
					}
				/>
				<link
					rel="alternate"
					hreflang="x-default"
					href={
						'https://lady4love.com' +
						location.pathname.replace(`/${lang}`, '/en')
					}
				/>
			</Helmet>

			<Header isLk />

			{isLoading ? <Loader height={100} /> : <Outlet />}

			<ButtonLink
				// onClick={() =>
				// 	dispatch(setShowAfterRegisterPreorderWarning(true))
				// }
				href={`https://wa.me/420774231617?text=Hello! I have a question / problem in my account on Lady4Love. (User agent: ${navigator.userAgent}) `}
				target="_blank"
				clazz="global-support button-s button--secondary _no-underline"
			>
				<Icon
					clazz={'color-green'}
					square
					size={'xxxl'}
					spritePath={'whatsapp'}
				/>
				{windowWidth > 768 && <span>{t('support')}</span>}
			</ButtonLink>

			<Footer />

			{/*  CRISTMAS NOTIFICATION  */}

			{
				<Popup
					open={decemberPromoPopup}
					setOpen={(val) => {
						dispatch(setShowDecemberPromoPopup(val));
					}}
					clazz="d-flex fd-column gap-8"
				>
					<h2>
						{'✨'} {t('christmaspromo')}{' '}
					</h2>
					<div className="popup-form__inner">
						<h2
							className="m0"
							style={{ margin: 0 }}
						>
							{t('getbonus')}
						</h2>
						<p>
							{'🎁'} {t('indecember')}
						</p>
						<ul>
							<li>
								{t('from')} 500 Kč / 20€ →{' '}
								<b className="color-green">+20 %</b>
							</li>
							<li>
								{t('from')} 1000 Kč / 40€ →{' '}
								<b className="color-green">+40 %</b>
							</li>
							<li>
								{t('from')} 2500 Kč / 100€ →{' '}
								<b className="color-green">+60 %</b>
							</li>
							<li>
								{t('from')} 5000 Kč / 200€ →{' '}
								<b className="color-green">+100 %</b>{' '}
								<b>(VIP {t('bonus')})</b>
							</li>
						</ul>
						<span className="color-green align-center">
							{''} {t('doublecredit')}
						</span>
						{(userTypeIndi || userTypeAgency) && (
							<ul>
								<li>
									{t('more')} {t('viewsov')}
								</li>
								<li>
									{t('more')} {t('orders')}
								</li>
								<li>
									{' '}
									<b>
										{t('more')} {t('earnings')}!
									</b>
								</li>
							</ul>
						)}
						<p
							className="align-center"
							style={{
								textAlign: 'center',
								marginBottom: '20px',
							}}
						>
							{'💖'} {t('merychristmas')}
						</p>
					</div>
					<Link
						className="button button-l button--green _no-underline "
						to="/lk/topup"
						onClick={() => {
							dispatch(setShowDecemberPromoPopup(false));
						}}
					>
						{t('topupbalance')}
					</Link>
				</Popup>
			}

			{/* AFTER REGISTER PREORDER WARN */}
			{
				<Popup
					closeOutside={() => {
						if (userTypeIndi || userTypeAgency) {
							return false;
						} else {
							return true;
						}
					}}
					open={showAfterRegisterPreorderWarning}
					clazz="d-flex fd-column gap-8"
				>
					{(userTypeIndi || userTypeAgency) && (
						<>
							<h2>{t('preorderoportunit')}</h2>
							<div className="popup-form__inner">
								<p>
									{t('prohibitedprepay')}{' '}
									<Link
										className="color-green"
										to={`/${lang}/rules`}
									>
										{t('portalrules')}
									</Link>
								</p>

								<p>
									{t('prepaygarance')}{' '}
									<Link
										className="color-green"
										to={`/${lang}/guide#onlineOrder`}
									>
										"{t('g-preorders')}"
									</Link>
									, {t('safeprepay')}
								</p>

								<Link
									to={`/${lang}/guide#onlineOrder`}
									className="text-center color-green"
								>
									{t('detailabout')}
								</Link>

								<div className="d-flex flex-wrap align-center justify-center">
									<Checkbox
										id={`check_agree_with_terms`}
										readOnly={true}
										checked={agreeWithTherms}
										onChange={() =>
											setAgreeWithTherms(!agreeWithTherms)
										}
									>
										<p>{t('iagree')}</p>
									</Checkbox>

									<Link
										to={`/${lang}/rules`}
										className="color-green text-center"
									>
										{t('portalrules')}
									</Link>
								</div>
							</div>
							<button
								className="button button-l button--green  mt-16"
								disabled={!agreeWithTherms}
								onClick={() => {
									localStorage.setItem(
										'check_terms',
										'checked',
									);
									dispatch(
										setShowAfterRegisterPreorderWarning(
											false,
										),
									);
								}}
							>
								{t('toclose')}
							</button>
						</>
					)}
					{userTypeCustomer && (
						<>
							<h2>
								{t('important')}!
								<br />
								{t('saveprepay')}
							</h2>
							<div className="popup-form__inner">
								<p>
									{t('guarantedpre')}
									{' – '}
									<Link
										onClick={() => {
											localStorage.setItem(
												'check_terms',
												'checked',
											);
											dispatch(
												setShowAfterRegisterPreorderWarning(
													false,
												),
											);
										}}
										className="color-green"
										to={`/${lang}/guide#preorders`}
									>
										{t('g-preorders')}
									</Link>
								</p>

								<p class="attention-box important">
									<span class="attention-box__word">
										{t('important')}!
									</span>{' '}
									{t('unfamiliar')}.
								</p>

								<p>{t('anydoubts')}</p>

								<h3>
									{t('usefilter')}:
									<br />
									<Link
										onClick={() => {
											localStorage.setItem(
												'check_terms',
												'checked',
											);
											dispatch(
												setShowAfterRegisterPreorderWarning(
													false,
												),
											);
										}}
										to={`/${lang}/czechia/booking`}
										className="text-center color-green"
									>
										{t('titleselect')} {t('withpreorder')}
									</Link>
								</h3>
							</div>
							<button
								className="button button-l button--green  mt-16"
								onClick={() => {
									localStorage.setItem(
										'check_terms',
										'checked',
									);
									dispatch(
										setShowAfterRegisterPreorderWarning(
											false,
										),
									);
								}}
							>
								{t('toclose')}
							</button>
						</>
					)}
				</Popup>
			}

			{insuffForAuto && <InsufFundsForActivationpopup data={dataInfo} />}
			{!!filterValue && <Filter />}
			{!!mapPopupStatus && userTypeIndi && <MapFilter />}
			{!!tariffsGuestPopup && <TarrifsListPopup />}
			<AfterAuth />
		</>
	);
};

export default LayoutLk;
